import { firestoreDb } from './firebase';
import {
    getFirestore,
    collection,
    addDoc,
    onSnapshot,
    serverTimestamp,
    doc,
    deleteDoc,
    getDocs,
} from 'firebase/firestore';

class FirebaseBroadcaster {
    constructor() {
        // console.log('sessionId:', sessionId, typeof sessionId);  // should be string
        this.commandsCol = collection(firestoreDb, 'broadcasts', 'all', 'commands');
    }

    async sendCommand(command, payload = {}) {
        try {
            const docRef = await addDoc(this.commandsCol, {
                command,
                payload,
                createdAt: serverTimestamp()
            });
            console.log('✅ wrote to', docRef.path);
            console.log('⚙️ projectId:', firestoreDb.app.options.projectId);
            return docRef;
        } catch (err) {
            console.error('❌ error writing command:', err);
            throw err;
        }
    }

    async verifyCommands() {
        const colRef = collection(firestoreDb, 'broadcasts', 'all', 'commands');
        console.log('⚙️ projectId:', firestoreDb.app.options.projectId);
        console.log('📂 path:', colRef.path);
        const snapshot = await getDocs(colRef);
        console.log(`🔥 found ${snapshot.size} docs:`);
        // snapshot.forEach(doc => console.log(doc.id, doc.data()));
    }

    async verifyServerCommands() {
        const colRef = collection(firestoreDb, 'broadcasts', 'all', 'commands');
        const snap = await getDocs(colRef, { source: 'server' });
        console.log(`💥 server has ${snap.size} docs`);
    }
}

export default FirebaseBroadcaster;